import BreadCrumb from "Components/Common/BreadCrumb"
import { withTranslation } from "react-i18next"
import { ToastContainer } from "react-toastify"
import { Container, Row } from "reactstrap"
import AdminNotificationSettings from "./AdminNotificationSettings"
import WorkspaceSettings from "./WorkspaceSettings"

const index = ({t}: any) => {
    return(
<>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("userpreferences.workspace_settings")} pageTitle={t("userpreferences.workspace_settings")} />
          <Row>
            <WorkspaceSettings />
          </Row>
        </Container>
      </div>
</>
    )
}
export default withTranslation()(index)